import { useAmplitude } from '@web/route-services/root/AmplitudeProvider';

export function useChatAnalytics() {
  const { ampli, isInitialized } = useAmplitude();
  
  return {
    trackMessageSent: (chatId: number, messageLength: number, characterCount: number, personaId?: number) => {
      if (!isInitialized) return;
      
      ampli.chatMessageSent({
        chatId,
        messageLength,
        characterCount,
        hasMultipleCharacters: characterCount > 1,
        personaId,
        timestamp: new Date().toISOString()
      });
    },
    
    trackChatContinue: (chatId: number, characterCount: number, personaId?: number) => {
      if (!isInitialized) return;
      
      ampli.chatContinue({
        chatId,
        characterCount,
        personaId,
        timestamp: new Date().toISOString()
      });
    },
    
    trackGenerationCompleted: (
      chatId: number, 
      characterId: number, 
      responseLength: number, 
      generationDurationMs: number,
      personaId?: number
    ) => {
      if (!isInitialized) return;
      
      ampli.chatGenerationCompleted({
        chatId,
        characterId,
        responseLength,
        generationDurationMs,
        personaId,
        timestamp: new Date().toISOString()
      });
    },
    
    trackGenerationError: (chatId: number, errorType: string, errorMessage: string) => {
      if (!isInitialized) return;
      
      ampli.chatGenerationError({
        chatId,
        errorType,
        errorMessage,
        timestamp: new Date().toISOString()
      });
    },
    
    trackMessageEdited: (chatId: number, messageId: number, messageType: string, personaId?: number) => {
      if (!isInitialized) return;
      
      ampli.chatMessageEdited({
        chatId,
        messageId,
        messageType,
        personaId,
        timestamp: new Date().toISOString()
      });
    },
    
    trackMessageDeleted: (chatId: number, messageId: number, messageType: string) => {
      if (!isInitialized) return;
      
      ampli.chatMessageDeleted({
        chatId,
        messageId,
        messageType,
        timestamp: new Date().toISOString()
      });
    },
    
    trackChatRewound: (chatId: number, messagesDeleted: number) => {
      if (!isInitialized) return;
      
      ampli.chatRewound({
        chatId,
        messagesDeleted,
        timestamp: new Date().toISOString()
      });
    },
    
    trackMessageRegenerated: (chatId: number, characterId: number, messageId: number, regenerationCount: number) => {
      if (!isInitialized) return;
      
      ampli.chatMessageRegenerated({
        chatId,
        characterId,
        messageId,
        regenerationCount,
        timestamp: new Date().toISOString()
      });
    }
  }
}